import Firebase from "../firebase";

class FirebaseRtdManager {
    constructor() {
        this.firebaseInstance = Firebase;
    }

    getFirebaseDbInstance(dbName) {
        return this.firebaseInstance.getInstance(dbName);
    }

    getDbRef(dbInstance, key) {
        try {
            const { ref, database } = dbInstance || {};
            return ref(database, key);
        } catch (e) {
            return e;
        }
    }

    disconnectFirebaseRtdConnection (dbInstance, key) {
        try {
            const { ref, database, onValue, off } = dbInstance || {};

            const connectionRef = ref(database, ".info/connected");
            onValue(connectionRef, (snap) => {
                if (snap.val() === true) {
                    const dbRef = ref(database, key);
                    off(dbRef);
                }
            });
            return null;
        } catch (e) {
            return e;
        }
    }

    setFirebaseRtdConnection(dbInstance, key, callback) {
        try {
            const db = this.getDbRef(dbInstance, key);
            const { onValue } = dbInstance || {};
            onValue(db, (snapshot) => {
                if (snapshot.exists()) {
                    callback(snapshot.val());
                }
            });
            return null;
        } catch (e) {
            return e;
        }
    }

    signInAndProceedToNextStep({dbInstance, key, rtdAuthToken}, callback) {
        const { getAuth, firebase } = dbInstance || {};
        const auth = getAuth(firebase);
        const { signInWithCustomToken } = dbInstance || {};
        signInWithCustomToken(auth, rtdAuthToken).then(() => {
            this.setFirebaseRtdConnection(dbInstance, key, callback);
        }).catch((e) => {
            return e;
        });
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new FirebaseRtdManager();
        }
        return this.instance;
    }
}

export const firebaseRtdManager = FirebaseRtdManager.getInstance();
